// extracted by mini-css-extract-plugin
module.exports = {"table":"WebhookEventsTable_table__1W54h"};